(() => {
  const init = () => {
    const root = document.querySelector('[data-jael-product="donde-estes"]');
    if (!root || root.dataset.jdeGalleryReady === 'true') return;
    const viewer = root.querySelector('[id^="GalleryViewer-"]');
    if (!viewer) return;
    const items = [...viewer.querySelectorAll('.product__media-item')];
    const dots = [...root.querySelectorAll('.thumbnail')];
    const previous = viewer.querySelector('.slider-button--prev');
    const next = viewer.querySelector('.slider-button--next');
    const current = viewer.querySelector('.slider-counter--current');
    if (items.length < 2 || dots.length !== items.length || !previous || !next) return;

    const activeIndex = () => {
      const dotIndex = dots.findIndex((dot) => dot.hasAttribute('aria-current'));
      if (dotIndex >= 0) return dotIndex;
      const itemIndex = items.findIndex((item) => item.classList.contains('is-active'));
      return Math.max(0, itemIndex);
    };
    const paint = (index) => {
      if (current) current.textContent = String(index + 1);
      previous.disabled = index === 0;
      next.disabled = index === items.length - 1;
    };
    const sync = () => paint(activeIndex());
    const activate = (index) => {
      const safeIndex = Math.min(items.length - 1, Math.max(0, index));
      dots[safeIndex].click();
      paint(safeIndex);
      window.setTimeout(sync, 600);
    };
    previous.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      activate(activeIndex() - 1);
    }, true);
    next.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      activate(activeIndex() + 1);
    }, true);
    dots.forEach((dot, index) => dot.addEventListener('click', () => {
      paint(index);
      window.setTimeout(sync, 600);
    }));
    root.dataset.jdeGalleryReady = 'true';
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
